import {Controller} from 'stimulus';
import {load} from '../../assets/request';
import {debounce} from "throttle-debounce";
import {calculateResultCount} from "../../assets/search-utils";
import {isResponsive} from "../../assets/utils";

export default class extends Controller {

  static targets = [
    'machineTypeId', 'attributes', 'manufacturerId', 'manufacturerName', 'manufacturerSelect', 'submitButton',
    'country', 'zipcode', 'distance', 'keyword', 'model'
  ];

  connect() {
    if (this.hasSubmitButtonTarget) {
      this.calculateResultCount = debounce(300, () => calculateResultCount(this.element, this.submitButtonTargets, this.element.dataset.type || "search"));
      this.element.addEventListener("change", this.calculateResultCount);
      if (this.hasKeywordTarget) {
        this.keywordTarget.addEventListener("input", this.calculateResultCount);
      }
      if (this.hasModelTarget) {
        this.modelTarget.addEventListener("input", this.calculateResultCount);
      }
    }
    if (this.hasManufacturerIdTarget) {
      this.onManufacturerIdChange();
    }
    if (this.hasCountryTarget) {
      this.countryTarget.addEventListener('change', () => this.onCountryChange());
      this.onCountryChange();
    }

    if (this.hasMachineTypeIdTarget) {
      this.machineTypeIdTarget.addEventListener('change', () => this.onMachineTypeIdChange());
    }
  }

  onMachineTypeIdChange() {
    const options = {
      data: {
        'type_id': this.machineTypeIdTarget.value
      },
      headers: {
        'TP-Layout': isResponsive() ? 'responsive' : null
      }
    };

    // Dynamische Felder neu laden
    if (this.hasAttributesTarget) {
      if (this.machineTypeIdTarget.name == 'machine_type_id') {
        load('/search/search/attributes/', this.attributesTarget, options)
          .catch(error => console.error(error));
      } else {
        this.attributesTarget.innerHTML = '';
      }
    }

    // Hersteller-Auswahl neu laden
    const manufacturer_id = this.manufacturerIdTarget.value;

    if (this.hasManufacturerSelectTarget && this.hasManufacturerIdTarget) {
      load('/search/search/manufacturerlist', this.manufacturerSelectTarget, options)
        .then(() => {
          this.manufacturerIdTarget.value = manufacturer_id;
          if (this.manufacturerIdTarget.value !== manufacturer_id) {
            // alter Wert in neuer Liste nicht verfügbar
            this.manufacturerIdTarget.value = -1;
          }
        })
        .then(() => this.onManufacturerIdChange())
        .catch(error => console.error(error));
    }
  }

  onManufacturerIdChange() {
    if (!this.hasManufacturerNameTarget) {
      return;
    }
    const active = (this.manufacturerIdTarget.value == '0');
    if (active) {
      // Sonstige
      this.manufacturerNameTarget.classList.remove('hidden');
    } else {
      this.manufacturerNameTarget.classList.add('hidden');
    }
    Array.from(this.manufacturerNameTarget.getElementsByTagName('input'))
      .forEach(element => element.disabled = !active);
  }

  onCountryChange() {
    if (this.hasZipcodeTarget) {
      if (this.countryTarget.value == 0) {
        this.zipcodeTarget.disabled = true;
        this.zipcodeTarget.value = '';
      } else {
        this.zipcodeTarget.disabled = false;
      }
    }
  }
}
